<app-toolbar></app-toolbar>

<div class="golden-layout-container" (keydown.alt.v)="versionPopupVisible = true">
  <div class="spawn-new"></div>
  <golden-layout-root [layout]="layoutConfig$"></golden-layout-root>
</div>

<dx-popup
  class="alert-popup"
  [width]="errors.alert.width"
  [height]="errors.alert.height"
  [elementAttr]="errors.alert.elementAttr"
  [showTitle]="errors.alert.title != null"
  [title]="errors.alert.title"
  [dragEnabled]="false"
  [toolbarItems]="errors.alert.buttons"
  [closeOnOutsideClick]="true"
  [(visible)]="errors.alert.visible">
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view>
      <div class="p-4" [innerHTML]="errors.alert.content"></div>
    </dx-scroll-view>
  </div>
</dx-popup>

<dx-popup
  class="info-popup"
  [width]="350"
  [height]="180"
  [showTitle]="true"
  title="Build Info"
  [dragEnabled]="false"
  (onShowing)="getVersion($event)"
  [closeOnOutsideClick]="true"
  [(visible)]="versionPopupVisible">
  <div *dxTemplate="let data of 'content'">
    <ul>
      <li><b>App Version:</b> {{AppBuildInfo.FullSemVer}}</li>
      <li><b>App Build Time:</b> {{AppBuildTime}}</li>
      <li><b>API Version:</b> {{APIBuildInfo.version}}</li>
      <li><b>API Build Time:</b> {{APIBuildInfo.build_time}}</li>
    </ul>
  </div>
</dx-popup>
